import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import {getUsers, suspendUser } from '../utils/requests';
import { fetchUsersSuccess, fetchUsersFailed, suspendUserSuccess, suspendUserFailed, fetchUsersRequest} from '../actions/users';

export function* fetchUsersWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.FETCH_USERS_REQUEST, fetchUsersRequestWatcher);
}

function* fetchUsersRequestWatcher() {
  try {
    const response = yield call(getUsers);

    yield put(fetchUsersSuccess(response.data));
  } catch(error) {
    let errorPayload = {};
    if (error.response) {
      errorPayload = error.response.data;
    }
    yield put(fetchUsersFailed(errorPayload));
  }
  
}

export function* suspendUserWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.SUSPEND_USER_REQUEST, suspendUserRequestWatcher);
}

function* suspendUserRequestWatcher(action) {
  try {
    const { payload } = action;
    const response = yield call(suspendUser, payload);

    yield put(suspendUserSuccess(response.data));
    yield put(fetchUsersRequest());
    

  } catch(error) {
    let errorPayload = {};
    if (error.response) {
      errorPayload = error.response.data;
    }
    
    yield put(suspendUserFailed(errorPayload));
  }
}